module.exports = {"id":"207523","name":"Slobodan Medojević","rating":"71","photo":"./data/images/photos/3/207523.png","club":{"name":"SV Darmstadt","logo":"./data/images/clubs/SVDarmstadt.png"},"positions":["MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SlobodanMedojevic0.json
// module id = 3980
// module chunks = 0